export default {
  title: 'Passerelles de paiement',
  fields: {
    name: 'Nom',
    payment_gateway: 'Passerelles de paiement',
    live_from: 'En ligne depuis',
    last_30_days_sales: 'Ventes des 30 derniers jours',
    kyc_deadlines: 'Échéances KYC',
    actions: 'Actions',
  },
  stats: {
    active_on_stripe: 'Actif sur Stripe',
    active_on_adyen: 'Actif sur Adyen',
    adyen_verification_pending: 'Vérification Adyen en attente',
  },
  filters: {
    search_placeholder: 'Rechercher par nom...',
    gateway_status_placeholder: 'Toutes les passerelles',
  },
  not_configured: {
    title: 'Les paiements ne sont pas encore configurés',
    description:
      "Aucun prestataire de paiement n'est connecté à votre compte. Les restaurants peuvent être entièrement configurés, mais ils ne peuvent pas être mis en ligne ni accepter des paiements en ligne tant que les paiements ne sont pas configurés.",
  },
  gateway_statuses: {
    stripe_as_primary: 'Stripe',
    adyen_as_primary: 'Adyen',
    adyen_pending: 'Adyen (En attente)',
  },
  gateways: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
  verification_statuses: {
    verified: 'Vérifié',
    pending: 'En attente',
    rejected: 'Rejeté',
  },
  buttons: {
    actions: 'Actions',
    switch_to: 'Passer à {{gateway}}',
    view_details: 'Voir les détails',
    open_onboarding: "Ouvrir l'onboarding",
    create_onboarding_link: "Créer un lien d'onboarding",
  },
  modal: {
    title: 'Changer de passerelle de paiement',
    description:
      'Voulez-vous vraiment passer {{companyName}} de <bold>{{currentGateway}}</bold> à <bold>{{targetGateway}}</bold> ?',
    not_verified_warning:
      "{{gateway}} n'est pas vérifié pour cette entreprise. Le traitement des paiements peut être affecté.",
    confirm: 'Changer',
    cancel: 'Annuler',
  },
  details_modal: {
    title: '{{companyName}} — Détails de la passerelle de paiement',
    requirements: 'Exigences',
    no_requirements: 'Aucune exigence en attente.',
    deadline: 'Échéance',
    capabilities: 'Capacités',
    onboarding_links: {
      section_title: "Lien d'onboarding",
      active_link: 'Lien actif',
      expires: 'Expire le {{date}}',
      create_button: 'Créer un lien',
      extend_button: 'Prolonger le lien',
      loading: 'Chargement des liens…',
    },
  },
  toasts: {
    onboarding_link_failed: "Impossible de créer le lien d'onboarding.",
    switch_success: 'Passerelle de paiement changée avec succès.',
    switch_failed: 'Impossible de changer la passerelle de paiement.',
    failed_to_load_data: 'Impossible de charger les données.',
  },
};
